import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import useAccessLevels from "../../../../hooks/use-access-levels";
import FormsListView from "./list";
import FormResponsesView from "./responses";

const FormManagementViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();
    const {bizForm} = operatorAccessLevels.packages;

    /**
     * Redirect to the first available sub-section if the user tries to access the base section.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.forms.base, exact: true})) {
            if (bizForm.formsList) {
                history.replace(routes.forms.list);
            } else if (bizForm.formResponsesList) {
                history.replace(routes.forms.responses);
            } else {
                history.replace(routes.forms.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [bizForm.formResponsesList, bizForm.formsList, history, location.pathname]);

    return (
        <Switch>
            <Route path={routes.forms.base} exact/>
            {
                bizForm.formsList &&
                <Route path={routes.forms.list} exact>
                    <FormsListView/>
                </Route>
            }
            {
                bizForm.formResponsesList &&
                <Route path={routes.forms.responses} exact>
                    <FormResponsesView/>
                </Route>
            }
            <Redirect to={routes.forms.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default FormManagementViews;
